"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _constants2 = require("settings-ui-sdk/Ecommerce/constants");

var getInitialPartialStatus = function getInitialPartialStatus(objectType) {
  return {
    downloadedCount: 0,
    initialCount: 0,
    initialized: false,
    objectType: objectType,
    processed: false,
    processingStarted: false,
    receivedAllPages: false
  };
};

var getInitialPartialStatuses = function getInitialPartialStatuses() {
  return _constants2.ObjectTypes.reduce(function (acc, _ref) {
    var key = _ref.key;
    acc[key] = getInitialPartialStatus(key);
    return acc;
  }, {});
};

var processPartialStatuses = function processPartialStatuses(partialStatuses) {
  return partialStatuses.reduce(function (acc, partialStatus) {
    acc[partialStatus.objectType] = partialStatus;
    return acc;
  }, {});
};

var defaults = {
  importStartedAt: null,
  importEndedAt: null,
  partialStatuses: getInitialPartialStatuses(),
  failures: [],
  stage: _constants.ImportStages.INITIALIZING,
  percentageComplete: null,
  isComplete: false,
  isFailed: false
};

var ImportDetails =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(ImportDetails, _Record);

  function ImportDetails() {
    (0, _classCallCheck2.default)(this, ImportDetails);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImportDetails).apply(this, arguments));
  }

  (0, _createClass2.default)(ImportDetails, null, [{
    key: "from",
    value: function from(data) {
      return new ImportDetails((0, _extends2.default)({}, data, {
        isComplete: data.stage === _constants.ImportStages.COMPLETE,
        isFailed: data.stage === _constants.ImportStages.FAILED,
        partialStatuses: processPartialStatuses(data.partialStatuses)
      }));
    }
  }]);
  return ImportDetails;
}((0, _immutable.Record)(defaults));

exports.default = ImportDetails;
module.exports = exports.default;